/**
 * @Author      Jhovanny Fragoso Marquez
 * @JobTitle    Frontend Developer
 * @Email       jfragoso@ibl.mx
 */

import { permissionObj } from "../../../../Helpers/permission"


//Tabs to show
export const TABS_FOODIE_ORDERS = {
    ORDER: {
        INDEX: 0,
        TRANS: "order"
    },
    MY_ORDERS: {
        INDEX: 1,
        TRANS: "my_orders"
    },
    REQUEST_MEALS: {
        INDEX: 2,
        TRANS: "request_meals"
    },
};

export const TABS_FOODIE_ORDERS_CONTRACTOR_SUPPLIER = {
    ACTIVE: {
        INDEX: 0,
        TRANS: "active"
    },
    HISTORY: {
        INDEX: 1,
        TRANS: "history"
    }
};

export const SUB_VIEW_MODEL = {
    REQUEST_MEALS: {
        ACTIVE: 'active',
        HISTORY: 'history',
    },
};

export function TAB_PERMISSION_FOODIE_ORDERS(subView) {
    return {
        CREATE: {
            [TABS_FOODIE_ORDERS.REQUEST_MEALS.INDEX]:
                subView === SUB_VIEW_MODEL.REQUEST_MEALS.ACTIVE
                    ? permissionObj?.WEB_FOODIE_EXTRA_REQUEST_CREATE
                    : undefined,
        },
        DELETE: {
            [TABS_FOODIE_ORDERS.ORDER.INDEX]: permissionObj?.WEB_FOODIE_MENU_SELECTION_UPDATE
        },
        EXPORT: {
            [TABS_FOODIE_ORDERS.REQUEST_MEALS.INDEX]:
                subView === SUB_VIEW_MODEL.REQUEST_MEALS.HISTORY
                    ? permissionObj?.WEB_FOODIE_EXTRA_REQUEST_EXPORT
                    : undefined,
        },
    }
}


export const MODEL_CONTEXT_ORDERS = {
    tabIndex: null,
    disabledBtnDelete: true,
    modalCreate: false,
    modalDelete: false,
}


